import { extra_resource_book_constant } from "./constants";

const init = [];

export const extra_resource_book = (state = init, action) => {
  switch (action.type) {
    case extra_resource_book_constant.CREATE_RESOURE_BOOK:
      return [action.payload, ...state];
    case extra_resource_book_constant.GET_RESOURCE_BOOK:
      return action.payload;
    case extra_resource_book_constant.DELETE_RESOURCE_BOOK:
      return state.filter((data) => data?.id !== action.payload);
    case extra_resource_book_constant.UPDATE_RESOURE_BOOK:
      return state.map((element) => {
        if (element.id === action.payload.id) {
          return { ...element, ...action.payload };
        }
        return element;
      });
    default:
      return state;
  }
};
